import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=f1cdde20"
import script from "./Levels.vue?vue&type=script&lang=js"
export * from "./Levels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports